var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Select',{attrs:{"placeholder":_vm.placeholder},on:{"on-change":_vm.change_value},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}},_vm._l((_vm.options),function(item,index){return _c('Option',{key:(index + "-" + (item.value)),attrs:{"value":item.value}},[_vm._v("\n    "+_vm._s(item.label)+"\n  ")])}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6fec130","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/basic-filter/BaseUser.vue
// module id = null
// module chunks = 